import { render } from "./StoreOnboardingStepConfiguration.vue?vue&type=template&id=2ea53ad4"
import script from "./StoreOnboardingStepConfiguration.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepConfiguration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__